import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Container } from '../../../../../SPRINTA/v2/atoms/Grid'
import Box from '../../../../../SPRINTA/atoms/Box'
import { Select } from '../../../../../SPRINTA/v2/atoms/Form'
import PlaceHolder from '../../../../../SPRINTA/v2/atoms/Placeholder'
import T from '../../../../../SPRINTA/translate/T'
import Font from '../../../../../SPRINTA/atoms/Font';
import * as documents from '../../../../utils/documents'
import Button from '../../../../../SPRINTA/v2/atoms/Button';
import UploadFile from '../../../../../SPRINTA/v2/molecules/UploadFile';
import Alert from '../../../../../SPRINTA/atoms/Alert';
import Dialog from '../../../../../SPRINTA/v2/molecules/Dialog';


function ConfigDocuments(props) {

    const d = useRef(null)

    const [loading, setLoading] = useState(true)
    const [statusDocument, setStatusDocument] = useState(0)
    const [data, setData] = useState([])
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [profileType, setProfileType] = useState('pf')
    const [loadingFile, setLoadingFile] = useState({})
    const [done, setDone] = useState({})

    function submitProfileType() {
        setLoadingBtn(true)
        documents.postProfileType(profileType)
        .then(() => {
            setLoadingBtn(false)
            setData({
                ...data,
                profileType 
            })
            
        })
    }

    function fileSubmit(file, type) {

        documents.postDocumentsUpload( file, type, (progress) => {
            setLoadingFile({
                ...loadingFile,
                [type]: progress
            })
        })
        .then(resp => {
            if(resp.errors.length > 0) {
                d.current.alert(resp.errors[0].message)
                setLoadingFile({
                    ...loadingFile,
                    [type]: false
                })
            }
            setDone({
                ...done,
                [type]: true
            })        
        })

    }

    useEffect(() => {
        documents.postDocumentsInfo()
        .then(( resp ) => {
            setData(resp)
            setLoading(false)
            setStatusDocument(resp.statusDocument)
        })
	}, [] )

    if (loading) {
        return (
            <div style={{ float: 'left', width: '100%' }}>
                <Loading />
            </div>
        )
    }

    const renderContent = () => {

        if(statusDocument > 0) {
            if(statusDocument === 1) {
                return (
                    <Col size='12'>
                        <Alert type='warning'>{T.txt("upload_status_1")}</Alert>
                    </Col>
                )
            }
            if(statusDocument === 2) {
                return (
                    <Col size='12'>
                        <Alert type='success'>{T.txt("upload_status_2")}</Alert>
                    </Col>
                )
            }
            if(statusDocument === 3) {
                return (
                    <Col size='12'>
                        <Alert type='danger'>{T.txt("upload_status_3")}</Alert>
                    </Col>
                )
            }
        }

        if (!data.profileType)
        return <React.Fragment>
            <Col size='12' spacing={1}>    
                <Box style={{background: '#f9f9f9', padding:'30px', borderRadius: '4px'}}>
                    <Font heading='3' weight="100" style={{marginBottom: '30px'}}>
                        {T.text('my_docs_certifiedUser')}
                    </Font>
                    <Select style={{width: 'auto'}} onChange={ (e) => setProfileType(e.target.value) } value={profileType} label={T.text('my_docs_type')}>
                        <option value='pf'>{T.txt('my_docs_pf')}</option>
                        <option value='pj'>{T.txt('my_docs_pj')}</option>
                    </Select>
                </Box>
            </Col>
            <Col size='12' text='right' spacing={1}>
                <Button primary loading={loadingBtn} inline submit>Salvar alterações</Button>
            </Col>
        </React.Fragment>

        return (
            <React.Fragment>
                <Col size='12' spacing={1}>
                    {
                        (loadingFile.identification === 100 && done.identification) || data.list.identification ? <Alert type='success'>{T.txt('upload_success_id')}</Alert> : <UploadFile title={T.txt('upload_title_id')} progress={loadingFile.identification} handleFile={ file => fileSubmit(file, "identification") } />
                    }
                </Col>
                { data.profileType === 'pj' && (
                    <Col size='12' spacing={1}>
                        { 
                            (loadingFile.contract === 100 && done.contract) || data.list.contract ? <Alert type='success'>{T.txt('upload_success_socialContract')}</Alert> : <UploadFile title={T.txt('upload_title_socialContract')} progress={loadingFile.contract} handleFile={ file => fileSubmit(file, "contract") } />
                        }
                    </Col>
                )}
                <Col size='12' spacing={1}>
                    { 
                        (loadingFile.address === 100 && done.address) || data.list.address ? <Alert type='success'>{T.txt('upload_success_address')}</Alert> : <UploadFile title={T.txt('upload_title_address')} progress={loadingFile.address} handleFile={ file => fileSubmit(file, "address") } />
                    }
                </Col>
            </React.Fragment>
        )
    }

    return (
        <form onSubmit={ (e) => { submitProfileType(); e.preventDefault() } }>
            <Row style={{float: 'left'}}>
                <Col size='12'>
                    <Font heading='3' weight="100">
                        {T.text('my_docs_title')}
                    </Font>
                    {statusDocument === 0 ? (
                        <Font style={{ margin: '30px 0' }}>
                            {T.text('my_docs_text')}
                        </Font>
                    ) : (
                        <div style={{ marginBottom: '30px' }} />
                    )}
                </Col>
                {renderContent()}
            </Row>
            <Dialog ref={d} />
        </form>
    )
}

export default ConfigDocuments

function Loading() {
    return (
        <div>
            <Container>
				<Row>
					<Col size='8 4' spacing={1}>
                        <PlaceHolder box style={{ height: '40px'}} />
                    </Col>
				</Row>
                <Row>
                    <Col size='12' spacing={1}>
                        <PlaceHolder box style={{ height: '300px'}} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigDocuments/index.js